// src/components/Dashboard/Dashboard.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Dashboard.css';

// Íconos para los módulos (puedes usar una librería como react-icons en lugar de emojis)
const icons = {
  ventas: '💰',
  inventario: '📦',
  clientes: '👥',
  reportes: '📊',
  config: '⚙️',
  usuarios: '👤',
  biometrico: '👆',
  mesas: '🪑',
  meseros: '🧑‍🍳',
  platillos: '🍽️',
  preparados: '🧪',
  corte: '💵',
  domicilio: '🚚',
  perfiles: '🔑',
  gastos: '💸',
  malas: '⚠️',
  promociones: '🏷️',
  precios: '🏷️',
  reportes_dia: '📅',
  reportes_esp: '📋',
  reportes_gen: '📈',
  compras: '🛒',
  'nueva-compra': '🛍️',
  'control-compras': '📋',
  criticos: '🚨',
  mermas: '📉',
  'salida-inventario': '🚚',
  'entrada-inventario': '📥'
};

const Dashboard = () => {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();


  // Función para verificar permisos
  const hasPermission = (permiso) => {
    if (!currentUser) return false;
    return currentUser[permiso] === '1' || currentUser[permiso] === 1;
  };

  const handleModuleClick = (e, path, requiredPermission) => {
    e.preventDefault();
    e.stopPropagation();

    console.log('Module clicked:', path, 'Permission:', requiredPermission);

    if (requiredPermission && !hasPermission(requiredPermission)) {
      alert('No tienes permisos para acceder a este módulo');
      return;
    }

    // Para todas las rutas, navegar normalmente
    console.log('Navigating to:', path);
    navigate(path);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Funciones de DigitalPersona removidas

  // Módulos organizados por categorías con permisos requeridos
  const modulesByCategory = {
    catalogos: [
      { id: 'clientes', name: 'Clientes', desc: 'Gestión de clientes', color: '#9C27B0', path: '/clientes', permission: 'cuentas' },
      { id: 'mesas', name: 'Mesas', desc: 'Administración de mesas', color: '#2196F3', path: '/mesas', permission: 'catalogoMesas' },
      { id: 'meseros', name: 'Meseros y Repartidores', desc: 'Gestión de personal', color: '#00BCD4', path: '/meseros', permission: 'catalogoMeseros' },
      { id: 'platillos', name: 'Platillos', desc: 'Gestión del menú', color: '#FF9800', path: '/platillos', permission: 'cuentas' },
      { id: 'preparados', name: 'Preparados', desc: 'Gestión de sub-recetas', color: '#4CAF50', path: '/preparados', permission: 'cuentas' },
      { id: 'precios', name: 'Actualizar Precios de Platillos', desc: 'Modificación de precios', color: '#8BC34A', path: '/actualizar-precios', permission: 'catalogoPlatillos' },
      { id: 'inventario', name: 'Inventario', desc: 'Control de inventario', color: '#2196F3', path: '/inventario', permission: 'inventario' }
    ],
    operaciones: [
      { id: 'corte', name: 'Corte de Caja', desc: 'Control de ingresos y salidas', color: '#1e5be9ff', path: '/corte-caja', permission: 'cuentas' },
      { id: 'domicilio', name: 'Liquidación de Pedidos a Domicilio', desc: 'Gestión de entregas', color: '#FF5722', path: '/liquidacion-domicilio', permission: 'cuentas1' },
      { id: 'gastos', name: 'Gastos', desc: 'Control de gastos', color: '#F44336', path: '/gastos', permission: 'gastos' },
      { id: 'mermas', name: 'Mermas', desc: 'Registro de mermas', color: '#795548', path: '/mermas', permission: 'merma' },
      { id: 'salida-inventario', name: 'Salida de Inventario', desc: 'Envío a sucursales', color: '#2e7d32', path: '/salida-inventario', permission: 'salida_inventario' },
      { id: 'entrada-inventario', name: 'Entrada de Inventario', desc: 'Recepción de mercancía', color: '#1565c0', path: '/entrada-inventario', permission: 'entrada_inventario' },
      { id: 'malas', name: 'Malas Ordenes y Garantías', desc: 'Gestión de devoluciones', color: '#9E9E9E', path: '/malas-ordenes-garantias', permission: 'cuentas1' },
      { id: 'reportes_dia', name: 'Reporte de Productos Vendidos por día', desc: 'Informes diarios', color: '#3F51B5', path: '/productos-vendidos', permission: 'reportes1' },
      { id: 'reportes_esp', name: 'Reportes Específicos', desc: 'Informes detallados', color: '#009688', path: '/reportes-especificos', permission: 'reportes1' },
      { id: 'reportes_gen', name: 'Reportes Generales', desc: 'Estadísticas e informes', color: '#03A9F4', path: '/reportes-generales', permission: 'reportes' },
      { id: 'criticos', name: 'Críticos', desc: 'Alertas de inventario', color: '#FF5252', path: '/criticos', permission: 'criticos' }
    ],
    configuracion: [
      { id: 'usuarios', name: 'Usuarios', desc: 'Gestión de usuarios', color: '#795548', path: '/usuarios', permission: 'catalogoUsuarios' },
      { id: 'perfiles', name: 'Perfiles', desc: 'Gestión de perfiles de acceso', color: '#673AB7', path: '/perfiles', permission: 'perfiles' },
      { id: 'config', name: 'Configuración', desc: 'Ajustes del sistema', color: '#607D8B', path: '/configuracion', permission: 'configuracion' },
      { id: 'promociones', name: 'Promociones', desc: 'Gestión de ofertas', color: '#CDDC39', path: '/promociones', permission: 'cuentas' },
      { id: 'biometrico', name: 'Biométricos', desc: 'Gestión de huellas digitales', color: '#3F51B5', path: '/biometrico', permission: 'gastos' }
    ]
  };

  // Título para cada categoría
  const categoryTitles = {
    catalogos: "CATÁLOGOS",
    operaciones: "OPERACIONES",
    configuracion: "CONFIGURACIÓNES"
  };

  // Módulo de ventas separado
  const ventasModule = {
    id: 'ventas',
    name: 'Ventas',
    desc: 'Gestión de pedidos y ventas',
    color: '#FFEB3B',
    path: '/ventas',
    permission: 'cuentas'
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>PRESTO V2</h1>
        <div className="user-info">
          <span>Usuario: {currentUser?.usuario || 'Admin'}</span>
          <button onClick={handleLogout} className="logout-button">Cerrar Sesión</button>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="dashboard-layout">
          <div className="categories-column">
            {Object.keys(modulesByCategory).map(category => (
              <div key={category} className="module-category">
                <h2 className="category-title">{categoryTitles[category]}</h2>
                <div className="module-column">
                  {modulesByCategory[category].map((module) => {
                    const hasModulePermission = hasPermission(module.permission);
                    return (
                      <div
                        key={module.id}
                        className={`module-card compact ${!hasModulePermission ? 'disabled' : ''}`}
                        style={{
                          backgroundColor: hasModulePermission ? module.color : '#ccc',
                          color: hasModulePermission ? 'white' : '#666',
                          cursor: hasModulePermission ? 'pointer' : 'not-allowed',
                          opacity: hasModulePermission ? 1 : 0.5,
                          display: ` ${!hasModulePermission ? 'none' : ''}`,
                        }}
                        onClick={(e) => handleModuleClick(e, module.path, module.permission)}
                        title={!hasModulePermission ? 'No tienes permisos para acceder a este módulo' : module.desc}
                      >
                        <div className="module-icon">{icons[module.id]}</div>
                        <h3>{module.name}</h3>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          <div className="ventas-column">
            {(() => {
              const hasVentasPermission = hasPermission(ventasModule.permission);
              return (
                <div
                  className={`ventas-card ${!hasVentasPermission ? 'disabled' : ''}`}
                  style={{
                    backgroundColor: hasVentasPermission ? ventasModule.color : '#ccc',
                    color: hasVentasPermission ? '#333' : '#666',
                    cursor: hasVentasPermission ? 'pointer' : 'not-allowed',
                    opacity: hasVentasPermission ? 1 : 0.5
                  }}
                  onClick={(e) => handleModuleClick(e, ventasModule.path, ventasModule.permission)}
                  title={!hasVentasPermission ? 'No tienes permisos para acceder a este módulo' : ventasModule.desc}
                >
                  <div className="ventas-icon">{icons[ventasModule.id]}</div>
                  <h2>{ventasModule.name}</h2>
                  <p>{ventasModule.desc}</p>
                </div>
              );
            })()}
          </div>
        </div>
      </div>

      {/* Sección de prueba DigitalPersona removida */}

      <footer className="dashboard-footer">
        Presto v2 © 2025
      </footer>

    </div>
  );
};

export default Dashboard;